<template>
  <div
    v-if="BannersMostrados.length"
    id="carouselBanners"
    class="carousel slide carrusel carousel-fade"
    data-bs-ride="carousel"
  >
    <!-- Banners -->
    <div class="carousel-inner">
      <div
        class="carousel-item"
        v-for="(banner, indice) in BannersMostrados"
        v-bind:key="banner.id"
        :class="{ active: indice == 0 }"
      >
        <img
          :src="CarpetaBanners + banner.nombre"
          class="d-block w-100"
          alt="..."
        />
      </div>
    </div>
    <!-- Botones -->
    <button
      class="carousel-control-prev"
      type="button"
      data-bs-target="#carouselBanners"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Anterior</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-bs-target="#carouselBanners"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Siguiente</span>
    </button>
  </div>
</template>
<script>
import { environment } from "../environments/environment";

import { Api } from "../api";
import { Carpetas } from "../constants";
import { TipoPantalla } from "../data/enums";

export default {
  data() {
    return {
      anchoVentana: 0,
      // Banners que se muestran en ambas pantallas (no son los chicos + los grandes)
      bannersAmbos: [],
      bannersChicos: [],
      bannersGrandes: [],
    };
  },
  computed: {
    AnchoVentana() {
      return this.anchoVentana;
    },
    BannersMostrados() {
      // Devuelve una lista con los banners correspondientes a la pantalla + los banners que se muestran en ambas pantallas
      if (this.EsPantallaChica)
        return [...this.bannersChicos, ...this.bannersAmbos];
      else return [...this.bannersGrandes, ...this.bannersAmbos];
    },
    /**Dirección de la carpeta de banners */
    CarpetaBanners() {
      return environment.API_URL + Carpetas.BANNERS;
    },
    EsPantallaChica() {
      return this.AnchoVentana < 576;
    },
  },
  methods: {
    ventanaRedimensionada() {
      this.anchoVentana = window.innerWidth;
    },
  },
  mounted() {
    Api.Banner.getTodos().then((response) => {
      const banners = response.data;

      this.bannersAmbos = banners.filter(
        (b) => b.pantalla == TipoPantalla.ambas
      );
      this.bannersChicos = banners.filter(
        (b) => b.pantalla == TipoPantalla.chica
      );
      this.bannersGrandes = banners.filter(
        (b) => b.pantalla == TipoPantalla.grande
      );
    });
  },
  created() {
    this.ventanaRedimensionada();
    // Se empieza a escuchar al evento de redimensión de ventana
    window.addEventListener("resize", this.ventanaRedimensionada);
  },
  destroyed() {
    // Se deja de escuchar al evento de redimensión de ventana
    window.removeEventListener("resize", this.ventanaRedimensionada);
  },
};
</script>
<style scoped>
.carrusel {
  z-index: 10;
}
.carousel-item {
  transition-duration: 0.7s;
}
</style>